function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon_focused_stroke",
  d: "M6.5 16C28.4355 16 35.0161 16 40.5 16",
  stroke: "#8AC341",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 10"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon_focused_stroke",
  d: "M34.5 23L41.5 16L34.5 9",
  stroke: "#8AC341",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 10"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 16,
  r: 8,
  fill: "#007BFF"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_focused",
  cx: 22,
  cy: 16,
  r: 11,
  stroke: "#8AC341",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 10"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon_selected_stroke6",
  d: "M6.5 16C28.4355 16 35.0161 16 40.5 16",
  stroke: "#373A3C",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon_selected_stroke6",
  d: "M34.5 23L41.5 16L34.5 9",
  stroke: "#373A3C",
  strokeWidth: 0,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 16,
  r: 8,
  fill: "#007BFF"
}), /*#__PURE__*/React.createElement("circle", {
  className: "icon_selected_stroke2",
  cx: 22,
  cy: 16,
  r: 9,
  stroke: "#373A3C",
  strokeWidth: 0
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 16C28.4355 16 35.0161 16 40.5 16",
  stroke: "#007BFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M34.5 23L41.5 16L34.5 9",
  stroke: "#007BFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 16,
  r: 8,
  fill: "#007BFF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "icon_selected_fill_gray",
  d: "M20.88 12.1813C20.88 11.8258 21.0009 11.5271 21.2427 11.2853C21.4844 11.0435 21.7831 10.9227 22.1387 10.9227C22.4942 10.9227 22.8 11.0435 23.056 11.2853C23.2978 11.5271 23.4187 11.8258 23.4187 12.1813L23.4187 14.8693L26.0853 14.8693C26.4409 14.8693 26.7395 14.9902 26.9813 15.232C27.2231 15.4595 27.344 15.7582 27.344 16.128C27.344 16.4836 27.2231 16.7822 26.9813 17.024C26.7395 17.2658 26.4409 17.3867 26.0853 17.3867H23.4187V20.0747C23.4187 20.4302 23.2978 20.7289 23.056 20.9707C22.8 21.2124 22.4942 21.3333 22.1387 21.3333C21.7831 21.3333 21.4844 21.2124 21.2427 20.9707C21.0009 20.7289 20.88 20.4302 20.88 20.0747V17.3867H18.192C17.8364 17.3867 17.5378 17.2658 17.296 17.024C17.0542 16.7822 16.9333 16.4836 16.9333 16.128C16.9333 15.7724 17.0542 15.4738 17.296 15.232C17.5378 14.9902 17.8364 14.8693 18.192 14.8693H20.88V12.1813Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d5",
  x: 4,
  y: 0,
  width: 36,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d2",
  x: 8,
  y: 4,
  width: 28,
  height: 28,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgPositiveSignalIcon = function SvgPositiveSignalIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    className: "svgIcon",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPositiveSignalIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/positive-signal-icon.ed45696a.svg";
export { ForwardRef as ReactComponent };